import { State } from '../state';

export enum ConfigurationDictionariesViews {
    ClientGroups = 'client-groups',
    ProductGroups = 'product-groups',
    Units = 'units',
    Countries = 'countries',
    AdjustmentReasons = 'adjustment-reasons',
    BankAccounts = 'bank-accounts',
    Currencies = 'currencies',
    MailTemplates = 'mail-templates',
    Expenses = 'expenses',
    OssVatRate = 'oss-vat-rate'

}

export enum ConfigurationParametersViews {
    Documents = 'documents',
    Fiscalization = 'fiscalization',
    Numberings = 'numberings',
    PrintingPatterns = 'printing-pattern',
    OnlineReceivers = 'online-receivers',
    Ksef = 'ksef',
    Inventory = 'Inventory',
    Integrations = 'Integrations',
    KsefSettings = 'KsefSettings'
}

export enum ConfigurationCompanyViews {
    Info = 'info',
    Taxes = 'taxes',
    Terms = 'terms',
    OtherSeller = 'other-seller',
    Users = 'users',
    Licences = 'licences',
    AdditionalData = 'additional-data',
    ContactDetails = 'contact-details',
}

export const configurationMenu: State = {
    url: 'configuration'
};

export const configurationDictionaries: State = {
    url: 'configuration/dictionaries',
    parent: configurationMenu
};

export const configurationCompanyForm: State = {
    url: 'configuration/company',
    parent: configurationMenu
};

export const configurationParameters: State = {
    url: 'configuration/parameters',
    parent: configurationMenu
};
